import {Component, EventEmitter, Input, Output} from '@angular/core';
import {INonDeloitteGuestRequest} from '@employee-models/data.models';
import {INonDeloitteGuestRequestWithPhoto} from '@employee-pages/badge-request-page/non-deloitte-visitors/non-deloitte.const';
import {BadgeRequestCategoryEnum} from '@employee-models/data.enums';
import {isPhotoRequiredCategory} from '@employee-pages/badge-request-page/common/photo-required-categories';

@Component({
    selector: 'employee-grid-non-deloitte',
    templateUrl: './grid-non-deloitte.component.html',
    styleUrl: './grid-non-deloitte.component.less'
})
export class GridNonDeloitteComponent {
    @Input() guestsData: INonDeloitteGuestRequestWithPhoto[];
    @Input() showAddGuestButton: boolean;
    @Input() categoryId: BadgeRequestCategoryEnum;

    @Output() newGuestForm = new EventEmitter<boolean>();
    @Output() deleteGuestData = new EventEmitter<string>();
    @Output() editGuestData = new EventEmitter<INonDeloitteGuestRequestWithPhoto[]>();
    @Input() isBadgeExtension: boolean = false;
    guestToEdit: INonDeloitteGuestRequestWithPhoto;
    guestIndex: number;
    isEdit = false;

    defaultImageUrl = '../../assets/img/badge-requests/no-photo.svg';

    // addNewGuest(): void {
    //     if (!this.guestToEdit) {
    //         this.newGuestForm.emit(true);
    //     }
    // }
    addNewGuest(isBadgeExtension: boolean = false): void {
    if (!this.guestToEdit) {
        // Prepare the guest payload
        const guestPayload: any = {}; // Replace with your actual payload structure
        guestPayload.isBadgeExtension = isBadgeExtension;
        // Emit the payload (or use it as needed in your logic)
        this.newGuestForm.emit(guestPayload);
    }
}

    deleteGuest(guest: INonDeloitteGuestRequest): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.deleteGuestData.emit(`${guest.firstName}${guest.lastName}${guest.localCellNumber}${guest.bloodGroupId}`);
        }
    }

    cancel(isCancel: boolean): void {
        this.guestToEdit = null;
        this.isEdit = false;
        this.guestIndex = null;
    }

    editGuest(updatedGuest: INonDeloitteGuestRequestWithPhoto): void {
        this.guestsData = this.guestsData.filter((item, index) => index !== this.guestIndex);

        this.guestsData = [
            ...this.guestsData.slice(0, this.guestIndex),
            updatedGuest,
            ...this.guestsData.slice(this.guestIndex)
        ];
        this.editGuestData.emit(this.guestsData);
        this.cancel(true);
    }

    openEditGuest(guest: any, guestIndex: number): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.guestToEdit = guest;
            this.isEdit = true;
            this.guestIndex = guestIndex;
        }
    }

    hasMissingPhoto(guest: { photoInfo?: any }): boolean {
        return isPhotoRequiredCategory(this.categoryId) && !guest?.photoInfo?.['file']?.url;
    }

}
